module.exports = __webpack_public_path__ + "img/user.692ccc34.png";